import styled from 'styled-components';
import colors from 'styles/colors';

export const TaxesFieldset = styled.fieldset`
  border-color: ${colors.fleetOffGray};
  border-radius: 3px;
  gap: 12px;
  margin-right: 0;
  margin-left: 0;
  display: flex;
  flex-direction: column;

  & legend {
    font-size: 12px;
  }
`;
